var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"secondary","to":_vm.url}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v("mdi-printer")]),_vm._v(" Report ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }